:host {
  /**
   * @prop --c-select-active-color: Active select color
   * @prop --c-select-inactive-color: Inactive select color
   * @prop --c-select-background-color: Inactive select background color
   * @prop --c-select-text-color: Select text color
   * @prop --c-select-placeholder-color: Select placeholder color
   * @prop --c-select-option-background-color: Select option background color
   * @prop --c-select-option-background-color-hover: Select option hover background color
   * @prop --c-select-option-text-color: Select option text color
   */
  --_c-select-active-color: var(--c-select-active-color, var(--c-primary-600));
  --_c-select-inactive-color: var(--c-select-inactive-color, var(--c-tertiary-600));
  --_c-select-background-color: var(--c-select-background-color, var(--c-transparent));
  --_c-select-text-color: var(--c-select-text-color, var(--c-text-body));
  --_c-select-placeholder-color: var(--c-select-placeholder-color, var(--c-tertiary-500));
  --_c-select-option-background-color: var(--c-select-option-background-color, var(--c-white));
  --_c-select-option-background-color-hover: var(--c-select-option-background-color-hover, var(--c-primary-100));
  --_c-select-option-text-color: var(--c-select-option-text-color, var(--c-text-body));
  --_c-select-shadow-active-color: var(--c-select-shadow-active-color, var(--_c-select-active-color));
  --_c-select-shadow-background-color: var(--c-select-shadow-background-color, var(--c-white));
  --_c-select-shadow-text-color: var(--c-select-shadow-text-color, var(--_c-select-text-color));
  --_c-select-shadow-placeholder-color: var(--c-select-shadow-placeholder-color, var(--_c-select-placeholder-color));

  // private
  --_c-input-active-color: var(--_c-select-active-color);
  --_c-input-inactive-color: var(--_c-select-inactive-color);
  --_c-input-background-color: var(--_c-select-background-color);
  --_c-input-text-color: var(--_c-select-text-color);
  --_c-input-placeholder-color: var(--_c-select-placeholder-color);
  --_c-input-shadow-active-color: var(--_c-select-shadow-active-color);
  --_c-input-shadow-background-color: var(--_c-select-shadow-background-color);
  --_c-input-shadow-text-color: var(--_c-select-shadow-text-color);
  --_c-input-shadow-placeholder-color: var(--_c-select-shadow-placeholder-color);
}

@import "../c-input/c-input-menu";
